// extracted by mini-css-extract-plugin
export var blue = "_4d-g";
export var brand = "_4d-c";
export var darkGrey = "_4d-f";
export var disabled = "_4d-5";
export var disabledSubtle = "_4d-6";
export var error = "_4d-7";
export var green = "_4d-h";
export var grey = "_4d-e";
export var icon = "_4d-0";
export var inherit = "_4d-b";
export var lightGrey = "_4d-d";
export var orange = "_4d-j";
export var pink = "_4d-l";
export var primary = "_4d-1";
export var purple = "_4d-m";
export var quaternary = "_4d-4";
export var red = "_4d-k";
export var secondary = "_4d-2";
export var success = "_4d-a";
export var tertiary = "_4d-3";
export var warning = "_4d-8";
export var warningSecondary = "_4d-9";
export var white = "_4d-n";
export var yellow = "_4d-i";